import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { STEPS } from '../../constants';
import Button from '../../../../../components/global/Button';

const propTypes = {
  setStep: PropTypes.func.isRequired,
  refetchAlbumFolder: PropTypes.func.isRequired,
};

const GiftingSuccessStep = ({ setStep, refetchAlbumFolder }) => {
  return (
    <Fragment>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <h2 className="text-black mb-2 text-center">
          Purchase complete!
          <br />
          Your gifts have been <br /> activated and sent!
        </h2>
      </div>
      <p className="text-light text-center">
        A receipt has been sent to your email.
      </p>
      <div className="text-center">
        <Button
          onClick={() => {
            refetchAlbumFolder();
            setStep(STEPS.HOME);
          }}
        >
          Back to home
        </Button>
      </div>
    </Fragment>
  );
};

GiftingSuccessStep.propTypes = propTypes;

export default GiftingSuccessStep;
